import { triggerSavedSearchActivatedEvent } from 'Services/analytics/events';
import { logger } from 'Services/logger/logger';
import { useResetFilters, useSetFilters } from 'Stores/FilterStore/VehicleListFilter/VehicleListFilterStore';
import { useSetIsLoadingFilter } from 'Stores/SavedFiltersActionsStore/SavedFiltersActionsStore';
import { useCurrentFilter, useSavedFilters, useSetCurrentFilter } from 'Stores/SavedFiltersStore/SavedFiltersStore';
import type { SavedFilter } from 'Types/savedFilter';

type UseToggleFilterReturnType = (id: SavedFilter['id']) => void;

const togglingTime = 700;

export const useToggleSavedFilter = (): UseToggleFilterReturnType => {
	const currentFilter = useCurrentFilter();
	const setCurrentFilter = useSetCurrentFilter();
	const setFilters = useSetFilters();
	const resetValues = useResetFilters();
	const savedFilters = useSavedFilters() as SavedFilter[];
	const setIsLoadingFilter = useSetIsLoadingFilter();

	const onToggleSavedFilter = (id: SavedFilter['id']) => {
		const isActivatedFilter = currentFilter === id;

		setIsLoadingFilter(true);
		resetValues();
		if (isActivatedFilter) {
			setCurrentFilter(undefined);
		} else {
			const selectedSavedFilter = savedFilters.find((filter) => filter?.id === id);

			if (!selectedSavedFilter) {
				logger.warn({ message: 'No matching saved filter was found', scope: 'useToggleSavedFilter' });
				return;
			}

			setCurrentFilter(id);
			setFilters({ filters: selectedSavedFilter?.filterData });
		}

		triggerSavedSearchActivatedEvent(!isActivatedFilter);

		setTimeout(() => {
			setIsLoadingFilter(false);
		}, togglingTime);
	};

	return onToggleSavedFilter;
};
